import { CALL_API } from "admin/middlewares/api";

export const USER_LOAN_LIST_GET_REQUEST = "USER_LOAN_LIST_GET_REQUEST";
export const USER_LOAN_LIST_GET_SUCCESS = "USER_LOAN_LIST_GET_SUCCESS";
export const USER_LOAN_LIST_GET_ERROR = "USER_LOAN_LIST_GET_ERROR";

export function get_loans_for_account(accountId) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/loans/byaccount?accountId=" + accountId,
      authenticatedRequest: true,
      types: [
        USER_LOAN_LIST_GET_REQUEST,
        USER_LOAN_LIST_GET_SUCCESS,
        USER_LOAN_LIST_GET_ERROR,
      ],
    },
  };
}

export const USER_LOAN_LIST_CHANGE_PAGE = "USER_LOAN_LIST_CHANGE_PAGE";

export function change_loan_list_page(page) {
  return {
    type: USER_LOAN_LIST_CHANGE_PAGE,
    page,
  };
}

export const USER_LOAN_LIST_CHANGE_FILTER = "USER_LOAN_LIST_CHANGE_FILTER";

export function change_loan_list_filter(key, value, type) {
  let filter = {};
  if (type === "dropdown") {
    filter[key] = value;
  } else {
    filter[key] = value;
  }

  return {
    type: USER_LOAN_LIST_CHANGE_FILTER,
    filter,
  };
}

export const USER_LOAN_REPAYMENT_REQUEST = "USER_LOAN_REPAYMENT_REQUEST";
export const USER_LOAN_REPAYMENT_SUCCESS = "USER_LOAN_REPAYMENT_SUCCESS";
export const USER_LOAN_REPAYMENT_ERROR = "USER_LOAN_REPAYMENT_ERROR";

export function full_repayment(loanId, accountId, date, amount) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/loans/repayment/create",
      authenticatedRequest: true,
      method: "POST",
      data: {
        CreditId: loanId,
        Amount: amount,
        Date: date,
        AccountId: accountId,
      },
      types: [
        USER_LOAN_REPAYMENT_REQUEST,
        USER_LOAN_REPAYMENT_SUCCESS,
        USER_LOAN_REPAYMENT_ERROR,
      ],
    },
  };
}

export const USER_GET_REPAYMENT_REQUEST = "USER_GET_REPAYMENT_REQUEST";
export const USER_GET_REPAYMENT_SUCCESS = "USER_GET_REPAYMENT_SUCCESS";
export const USER_GET_REPAYMENT_ERROR = "USER_GET_REPAYMENT_ERROR";

export function get_full_repayment(loanId, date) {
  return {
    [CALL_API]: {
      endpoint:
        "/api/admin/loans/fullrepayment?loanId=" + loanId + "&date=" + date,
      authenticatedRequest: true,
      method: "GET",
      data: { CreditId: loanId },
      types: [
        USER_GET_REPAYMENT_REQUEST,
        USER_GET_REPAYMENT_SUCCESS,
        USER_GET_REPAYMENT_ERROR,
      ],
    },
  };
}

export const USER_REMOVE_FEES_REQUEST = "USER_REMOVE_FEES_REQUEST";
export const USER_REMOVE_FEES_SUCCESS = "USER_REMOVE_FEES_SUCCESS";
export const USER_REMOVE_FEES_ERROR = "USER_REMOVE_FEES_ERROR";

export function remove_fees(data, removalType) {
  let url = "/api/admin/invoices/";
  switch (removalType) {
    case "all":
      url += "fees/remove-all";
      break;
    case "byType":
      url += "fees/remove-by-type";
      break;
    case "byTypeOnDate":
      url += "fees/remove-by-type-on-date";
      break;
    case "allOnDate":
      url += "fees/remove-all-on-date";
      break;
    case "allSinceDate":
      url += "fees/remove-all-since-date";
      break;
    case "byTypeSinceDate":
      url += "fees/remove-by-type-since-date";
      break;
  }

  return {
    [CALL_API]: {
      endpoint: url,
      authenticatedRequest: true,
      data: data,
      method: "POST",
      types: [
        USER_REMOVE_FEES_REQUEST,
        USER_REMOVE_FEES_SUCCESS,
        USER_REMOVE_FEES_ERROR,
      ],
    },
  };
}

export const USER_LOAN_STATUS_UPDATE_REQUEST =
  "USER_LOAN_STATUS_UPDATE_REQUEST";
export const USER_LOAN_STATUS_UPDATE_SUCCESS =
  "USER_LOAN_STATUS_UPDATE_SUCCESS";
export const USER_LOAN_STATUS_UPDATE_ERROR = "USER_LOAN_STATUS_UPDATE_ERROR";

export function update_loan_status(creditId) {
  let url = "/api/admin/loans/regret";

  return {
    [CALL_API]: {
      endpoint: url,
      authenticatedRequest: true,
      data: { LoanId: creditId },
      method: "POST",
      types: [
        USER_LOAN_STATUS_UPDATE_REQUEST,
        USER_LOAN_STATUS_UPDATE_SUCCESS,
        USER_LOAN_STATUS_UPDATE_ERROR,
      ],
    },
  };
}
